import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { mutationKeys } from '../mutationKeys';
import { ROUTE_PATHS } from '../../../routes/Routes';
import { EmployeeTemplate } from '../../../types/EmployeeTemplate';

export const postEmployeeTemplate = async (formData: EmployeeTemplate) => {
  const response = await CustomAxios.post(`employee_templates`, formData);
  return response.data;
};

type UseCreateEmployeeTemplateProps = {
  onSuccessCallback: (data: EmployeeTemplate) => void;
};

export function useCreateEmployeeTemplate({ onSuccessCallback }: UseCreateEmployeeTemplateProps) {
  const navigate = useNavigate();

  return useMutation({
    mutationKey: [mutationKeys.createEmployeeTemplate],
    mutationFn: (formData: EmployeeTemplate) => postEmployeeTemplate(formData),
    onSuccess: (data: EmployeeTemplate) => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.allEmployeeTemplates, 'new'],
      });
      onSuccessCallback(data);
      navigate(`/${ROUTE_PATHS.EMPLOYEE_TEMPLATES}/${data.uuid}`);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const template = err.response.data as EmployeeTemplate;
        queryClient.setQueryData([queryKeys.allEmployeeTemplates, 'new'], template);
      }
    },
  });
}
